module.exports = __webpack_public_path__ + "static/images/smartspot-performance-sv.7bf9fee427fe66ba4a87f266d297bd80.png";